import './polyfills/global'
import './index.css'

import App from './App.tsx'
import React from 'react'
import ReactDOM from 'react-dom/client'

const root = ReactDOM.createRoot(document.getElementById('root')!)
if (import.meta.env.DEV && new URLSearchParams(window.location.search).get('preview') === 'ui') {
    import('./components/ShopPreview').then(({ default: ShopPreview }) => {
        root.render(<React.StrictMode><ShopPreview /></React.StrictMode>)
    })
} else {
    root.render(<React.StrictMode><App /></React.StrictMode>)
}

